import React, { useState } from "react";
import { GlButton } from "@adl/component-button";
import { GlCheckbox } from "@adl/component-checkbox";
import { useTranslations } from "@crystal/translator";
import styles from "../consents.module.scss.js";
import { ExplicitConsentModal } from "./explicit-consent-modal.js";
import { ExplicitConsentTransition } from "./explicit-consent-transition.js";
const ExplicitConsentCheckBox = ({
  consent: { label, cta, close, details },
  isChecked,
  required,
  onChange,
  transitionDuration = 1,
  className,
  name,
  error
}) => {
  const t = useTranslations();
  const [showDetails, setShowDetails] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { id: `pms-checkbox-${name}` }, /* @__PURE__ */ React.createElement(
    GlCheckbox,
    {
      name,
      isChecked,
      errorText: error && t("errorforms.required.checkbox"),
      required,
      className: `consent-checkbox ${className}`,
      onChange,
      error,
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { dangerouslySetInnerHTML: { __html: label }, className: styles.legalText }), cta && !!(details == null ? void 0 : details.length) && /* @__PURE__ */ React.createElement(
        GlButton,
        {
          className: "gl-link",
          variant: "tertiary",
          "data-auto-id": "consent-details-open",
          onClick: () => {
            setShowDetails(!showDetails);
          }
        },
        cta
      ))
    }
  )), !!(details == null ? void 0 : details.length) && /* @__PURE__ */ React.createElement(React.Fragment, null, (details == null ? void 0 : details[0]) ? /* @__PURE__ */ React.createElement(
    ExplicitConsentModal,
    {
      showDetails,
      details: details[0],
      onClick: () => setShowDetails(!showDetails)
    },
    /* @__PURE__ */ React.createElement(
      ExplicitConsentTransition,
      {
        transitionDuration,
        showDetails: showMoreDetails,
        details: details[1],
        closeText: close,
        onClick: () => setShowMoreDetails(!showMoreDetails)
      }
    )
  ) : /* @__PURE__ */ React.createElement(
    ExplicitConsentTransition,
    {
      transitionDuration,
      showDetails,
      details: details[0],
      closeText: close,
      onClick: () => setShowDetails(!showDetails)
    }
  )));
};
export {
  ExplicitConsentCheckBox as default
};
//# sourceMappingURL=explicit-consent-checkbox.js.map
